const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Helper function to handle API responses
const handleResponse = async (response) => {
    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        console.error('API Error Response:', {
            status: response.status,
            statusText: response.statusText,
            error: error,
            errorDetails: error.details,
            errorMessage: error.message
        });
        throw new Error(error.message || `API request failed (${response.status})`);
    }
    return response.json();
};

// Helper function to get common headers
const getHeaders = (accountId) => ({
    'Content-Type': 'application/json',
    'X-Hedera-Account-Id': accountId
});

// Gallery API operations
export const galleries = {
    // Get all galleries for the current user
    async getUserGalleries(accountId) {
        const response = await fetch(`${API_BASE_URL}/api/galleries/user`, {
            credentials: 'include',
            headers: getHeaders(accountId)
        });
        return handleResponse(response);
    },

    // Get a gallery by slug
    async getGalleryBySlug(slug, accountId) {
        const headers = accountId ? getHeaders(accountId) : { 'Content-Type': 'application/json' };
        const response = await fetch(`${API_BASE_URL}/api/galleries/${slug}`, {
            headers,
            credentials: accountId ? 'include' : 'omit'
        });
        const data = await handleResponse(response);
        console.log('API getGalleryBySlug response:', {
            slug: data.slug,
            roomType: data.roomType,
            glbPath: data.glbPath
        });
        
        // If the roomType is custom-glb but glbPath is missing, add a default
        if (data.roomType === 'custom-glb' && !data.glbPath) {
            console.warn('Gallery has custom-glb roomType but no glbPath, adding default path');
            data.glbPath = '/rooms/RoomTemplate.glb';
        }
        
        return data;
    },

    // Create a new gallery
    async create(galleryData, accountId) {
        const { name, description, theme, customization, roomType, glbPath } = galleryData;
        
        console.log('=== API CREATE GALLERY DEBUG ===');
        console.log('Full galleryData received:', JSON.stringify(galleryData, null, 2));
        console.log('Extracted roomType:', roomType);
        console.log('Extracted glbPath:', glbPath);
        console.log('typeof roomType:', typeof roomType);
        const requestBody = {
            name,
            description,
            theme,
            customization,
            roomType,
            glbPath
        };
        
        console.log('Request body being sent:', JSON.stringify(requestBody, null, 2));
        
        const response = await fetch(`${API_BASE_URL}/api/galleries`, {
            method: 'POST',
            headers: getHeaders(accountId),
            credentials: 'include',
            body: JSON.stringify(requestBody)
        });
        const data = await handleResponse(response);
        console.log('API create response data:', data);
        console.log('API create response roomType:', data.roomType);
        return data;
    },

    // Update gallery assets
    async updateAssets(galleryId, assets, accountId) {
        console.log('API sending update:', {
            galleryId,
            assets,
            accountId
        });

        const response = await fetch(`${API_BASE_URL}/api/galleries/${galleryId}/assets`, {
            method: 'PUT',
            headers: getHeaders(accountId),
            credentials: 'include',
            body: JSON.stringify({ assets })
        });

        const data = await handleResponse(response);
        console.log('API received response:', data);
        return data;
    },

    // Update gallery settings
    async updateSettings(galleryId, settings, accountId) {
        const response = await fetch(`${API_BASE_URL}/api/galleries/${galleryId}`, {
            method: 'PUT',
            headers: getHeaders(accountId),
            credentials: 'include',
            body: JSON.stringify(settings)
        });
        return handleResponse(response);
    },

    // Delete a gallery
    async delete(galleryId, accountId) {
        const response = await fetch(`${API_BASE_URL}/api/galleries/${galleryId}`, {
            method: 'DELETE',
            headers: getHeaders(accountId),
            credentials: 'include'
        });
        return handleResponse(response);
    }
}; 